import { Component } from "preact";
import { connectWithTranslations } from "../../common/helpers/translationsHelpers";
import actions from "../actions";
import { GTM_ID, GA4EVENT } from "../constants";
import SoundAlert from "../../calendar-common/components/SoundAlert";
import ConfigureView from "../../calendar-common/components/ConfigureView";
import IconSearchSolid from "../../common/components/icons/IconSearchSolid";
class SettingsOptions extends Component {
    constructor(props) {
        super(props);
    }

    filter = (e) => {
        if (e.isComposing || e.keyCode === 229) {
            return;
        }
        let value = e.target.value;
        this.props.search(value);
    };

    render({
        config,
        data,
        translate,
        onCheckboxChanged,
        notificationSoundOn,
        view,
        onOptionChange,
        toggle,
        onApply,
    }) {
        return (
            <div>
                <div class="fxs_detail fxs_cs_detail">
                    <h2 class="fxs_headline_from_small_to_medium fxs_marginBase_bottom_big">
                        {translate("Notifications_Title")}
                    </h2>
                    <SoundAlert
                        onCheckboxChanged={() => onCheckboxChanged()}
                        notificationSoundOn={notificationSoundOn}
                        locale={this.props.config.culture}
                    ></SoundAlert>
                    <ConfigureView
                        view={view}
                        onOptionSelected={(option) => onOptionChange(option)}
                        showDescription={true}
                        locale={this.props.config.culture}
                    ></ConfigureView>
                    {(config.notificationsHelper ||
                        config.hasNotifications) && (
                            <div>
                                <h3 class="fxs_headline_small">
                                    {translate("Notifications")}
                                </h3>
                                <p class="fxs_entryPlain_txt">
                                    {translate("Notifications_Summary_1")}
                                    <br />
                                    {translate("Notifications_Summary_2")}
                                </p>
                                <div class="fxs_search_module fxs_cs_search_module">
                                    <div class="fxs_search_box fxs_cs_search_box">
                                        <label
                                            for="searchEvent"
                                            class="fxs_btn_filter"
                                            title="Search event"
                                        >
                                            <IconSearchSolid />
                                            <span class="fxs_skip">
                                                {" "}
                                                {translate(
                                                    "Notifications_Search_Event"
                                                )}
                                            </span>
                                        </label>
                                        <input
                                            onKeyUp={this.filter}
                                            type="search"
                                            class="fxs_search_input"
                                            placeholder="Search event"
                                            name="search"
                                            autocomplete="off"
                                        />
                                    </div>
                                </div>
                                <div class="fxs_cs_table_wrapper">
                                    <table class="fxs_cs_table">
                                        <thead class="fxs_cs_header">
                                            <tr>
                                                <th class="fxs_cs_item">
                                                    {translate(
                                                        "Notifications_NotifyMe"
                                                    )}
                                                </th>
                                                <th class="fxs_cs_item" colspan="2">
                                                    {translate(
                                                        "Notifications_Currency"
                                                    )}
                                                </th>
                                                <th class="fxs_cs_item fxs_cs_event">
                                                    {translate(
                                                        "Notifications_Event"
                                                    )}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data &&
                                                data
                                                    .filter((x) => x.isVisible)
                                                    .map((item) => (
                                                        <tr class="fxs_cs_row">
                                                            <td class="fxs_cs_item fxs_cs_checkbox">
                                                                <input
                                                                    key={
                                                                        item.id +
                                                                        "_calendarsettings"
                                                                    }
                                                                    type="checkbox"
                                                                    value={item.id}
                                                                    checked={
                                                                        item.checked
                                                                    }
                                                                    onClick={() =>
                                                                        toggle(item)
                                                                    }
                                                                    data-gtmid={
                                                                        config.tracking &&
                                                                        GTM_ID.CONFIGURATION_PUSH_SELECT(
                                                                            item.id,
                                                                            item.checked
                                                                        )
                                                                    }
                                                                    data-ga4event-clk-name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                                                                    data-ga4event-element={config.tracking && GA4EVENT.ELEMENTS.CONFIGURATION_PUSH_SELECT(item.checked)}
                                                                    data-ga4event-eventdateid={item.id}
                                                                ></input>
                                                            </td>
                                                            <td class="fxs_cs_item fxs_cs_flag">
                                                                <span
                                                                    class={`fxs_flag fxs_${item.countryCode.toLowerCase()}`}
                                                                ></span>
                                                            </td>
                                                            <td class="fxs_cs_item fxs_cs_currency">
                                                                <span>
                                                                    {
                                                                        item.currencyCode
                                                                    }
                                                                </span>
                                                            </td>
                                                            <td class="fxs_cs_item fxs_cs_name">
                                                                {item.name}
                                                            </td>
                                                        </tr>
                                                    ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    <button
                        type="button"
                        onClick={() => onApply(data)}
                        class="fxs_btn fxs_btn_cta fxs_fRight fxs_marginBase_top"
                        role="button"
                        data-gtmid={
                            config.tracking && GTM_ID.CONFIGURATION_APPLY
                        }
                        data-ga4event-clk-name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                        data-ga4event-element={config.tracking && GA4EVENT.ELEMENTS.CONFIGURATION_APPLY}

                    >
                        {translate("Notifications_Apply")}
                    </button>
                </div>
            </div>
        );
    }
}
export default connectWithTranslations(
    "settings, config, data",
    actions
)(SettingsOptions);
